<script lang="ts" setup>
import { getCmsImage } from '#imports';

defineProps<{ title: string; features: any[] }>();
</script>

<template>
  <div class="py-8">
    <VContainer>
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        <div v-for="feature in features" class="flex flex-col gap-2 p-4">
          <div class="flex items-start shrink-0">
            <NuxtImg class="size-12" :src="getCmsImage(feature.images)" alt="" />
          </div>
          <div class="flex flex-col w-full">
            <span class="font-semibold text-lg text-gray-900">{{ feature.heading }}</span>
            <div class="prose max-w-none text-gray-800" v-html="feature.body?.html"></div>
          </div>
        </div>
      </div>
    </VContainer>
  </div>
</template>
